import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-row justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-400" }, "Template title", -1)
const _hoisted_4 = { class: "flex flex-row space-x-2 items-center lg:hidden" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "font-semibold capitalize" }
const _hoisted_7 = { class: "flex flex-col lg:flex-row justify-between py-2" }
const _hoisted_8 = { class: "flex flex-col lg:flex-row justify-between lg:space-x-5" }
const _hoisted_9 = { class: "flex flex-row items-center lg:items-start space-x-3 lg:space-x-0 lg:flex-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-500 font-medium" }, " Created by ", -1)
const _hoisted_11 = { class: "flex flex-row items-center lg:items-start space-x-3 lg:flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-500 font-medium" }, "Last interaction", -1)
const _hoisted_13 = { class: "text-xs font-light" }
const _hoisted_14 = { class: "lg:flex flex-row justify-between space-x-3 hidden" }
const _hoisted_15 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "h-5 w-5",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("path", { d: "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "text-xs" }
const _hoisted_22 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuEvaluation = _resolveComponent("MenuEvaluation")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: `item-card-${index + 1}`,
      class: "flex flex-col bg-white shadow-lg rounded-2xl px-8 py-4 w-full my-2 hover:border-2 hover:border-gray-600"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(["rounded-lg py-1 px-3 text-xs", [
              item.is_assigned
                ? ' bg-blue-100 text-blue-400'
                : ' bg-orange-100 text-orange-500',
            ]])
            }, _toDisplayString(item.is_assigned ? "Assigned" : "Not assigned"), 3),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_MenuEvaluation, {
                templateId: item.id,
                onArchiveTemplate: _ctx.archiveTemplate,
                onCopyTemplate: _ctx.copyTemplate
              }, null, 8, ["templateId", "onArchiveTemplate", "onCopyTemplate"])
            ])
          ])
        ]),
        _createElementVNode("span", _hoisted_6, _toDisplayString(item.title), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", {
              class: _normalizeClass(["text-xs font-light", [item.staff ? 'text-primary' : 'text-gray-500']])
            }, _toDisplayString(item.staff
                ? item.staff.first_name + " " + item.staff.last_name
                : "No information"), 3)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.timeAgo(new Date(item.updated_at))), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["px-3 py-2 bg-orange-100 text-orange-500 rounded flex flex-row items-center space-x-2", [
            item.is_assigned
              ? ' bg-blue-100 text-blue-400'
              : ' bg-orange-100 text-orange-500',
          ]])
          }, [
            (!item.is_assigned)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17))
              : (_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_20)),
            _createElementVNode("span", _hoisted_21, _toDisplayString(item.is_assigned ? "Assigned" : "Not assigned"), 1)
          ], 2),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_MenuEvaluation, {
              templateId: item.id,
              onArchiveTemplate: _ctx.archiveTemplate,
              onCopyTemplate: _ctx.copyTemplate
            }, null, 8, ["templateId", "onArchiveTemplate", "onCopyTemplate"])
          ])
        ])
      ])
    ]))
  }), 128))
}